import { render, staticRenderFns } from "./ModalShare.vue?vue&type=template&id=07bced50&scoped=true&"
import script from "./ModalShare.vue?vue&type=script&lang=js&"
export * from "./ModalShare.vue?vue&type=script&lang=js&"
import style0 from "./ModalShare.vue?vue&type=style&index=0&id=07bced50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bced50",
  null
  
)

export default component.exports